// Client-safe exports for credit report types
// This file has no dependencies on MongoDB or server-side code

export enum CreditReportType {
  Prequal = 'prequal',
  Dit = 'dit',
  PrequalCombined = 'prequal-combined',
  PrequalCoborrower = 'prequal-coborrower'
}

export type CreditReportData = {
  _id?: string
  source: string
  reportType: CreditReportType | string
  report: any
  request?: any
  combinedFrom?: string
  combinedWith?: string
  comboName?: string
  consumerId?: string
  principalId?: string
  prescreenRequestId?: string
  loanAppId?: string
  prequalResult?: string
  ditDecision?: string
}

